import React, { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAccount } from 'wagmi';
import { isAuthenticated, isMobileDevice } from '../utils/authHelpers';
import { toast } from 'react-hot-toast';

/**
 * Componente para proteger rutas que requieren autenticación
 * Redirige a la página principal si el usuario no está autenticado
 */
const PrivateRoute = ({ component: Component, ...rest }) => {
  const { address, isConnecting, isConnected } = useAccount();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [isAuth, setIsAuth] = useState(false);
  
  // Comprobar autenticación, teniendo en cuenta el estado de conexión
  useEffect(() => {
    const checkAuth = async () => {
      // Si aún se está conectando, no hacer nada
      if (isConnecting) return;
      
      // Verificar autenticación basada en la dirección actual o almacenada
      const authenticated = isAuthenticated(address);
      setIsAuth(authenticated);
      setIsCheckingAuth(false);
      
      // Registro para depuración
      console.log(`[PrivateRoute] Auth check - address: ${address}, isConnected: ${isConnected}, isAuth: ${authenticated}, isMobile: ${isMobileDevice()}`);
    };
    
    checkAuth();
  }, [address, isConnecting, isConnected]);
  
  return (
    <Route
      {...rest}
      render={(props) => {
        // Si todavía está verificando o conectando, mostrar carga
        if (isCheckingAuth || isConnecting) {
          return (
            <div className="flex items-center justify-center min-h-screen">
              <div className="text-center">
                <div className="w-16 h-16 border-4 border-t-4 border-[#45c0be] rounded-full animate-spin"></div>
                <p className="mt-4 text-white">Verificando conexión...</p>
              </div>
            </div>
          );
        }
        
        // Si está autenticado, renderizar el componente normalmente
        if (isAuth) {
          return <Component {...props} {...rest} />;
        } 
        
        // Si está en dispositivo móvil y la wallet está conectada pero no autenticada
        // (puede ocurrir por problemas de localStorage en móviles)
        if (isMobileDevice() && isConnected) {
          console.log('[PrivateRoute] Wallet conectada en móvil pero no autenticada, permitiendo acceso');
          return <Component {...props} {...rest} />;
        }
        
        // Si no está autenticado, mostrar mensaje y redirigir a la página principal
        toast.error('Necesitas conectar tu wallet para acceder a esta página');
        return (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location }
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute; 